import { BffGamesCategory } from '@lucky7ventures/bff-types';

export const PROVIDERS_OPTIONS_MEXICO = [
  '4ThePlayer',
  'Alchemy Gaming',
  'All For One Studios',
  'AreaVegas Games',
  'Aurum Signature Studios',
  'Avatar UX',
  'Barstruck',
  'Blue Guru Games',
  'Blue Ring Studios',
  'Buck Stakes Entertainment',
  'Circular Arrow',
  'Coin Machine Gaming',
  'Crazy Tooth Studio',
  'Evolution',
  'Fantasma Games',
  'FBM',
  'Flip Five Gaming',
  'Fortune Factory Studios',
  'Four Leaf Gaming',
  'Foxium',
  'Gameburger Studios',
  'Games Global',
  'Gold Coin Studios',
  'Gong Gaming',
  'Half Pixel Studios',
  'Hammertime Games',
  'High Limit Studios',
  'Infinity Dragon Studios',
  'INO Games',
  'Just For The Win',
  'Nailed It! Games',
  'Neko Games',
  'Neon Valley Studios',
  'NetEnt',
  'Northern Lights',
  'Oros Gaming',
  'Oryx Gaming',
  'PearFiction Studios',
  'Peter & Sons',
  'Playtech',
  'Pragmatic Play',
  'Print Studios',
  'Real Dealer Studios',
  'Red Tiger',
  'Relax Gaming',
  'Silverback',
  'Slingshot Studios',
  'Snowborn Games',
  'SpinPlay Games',
  'Storm Gaming',
  'Stormcraft Studios',
  'Switch Studios',
  'Trigger',
  'Triple Edge Studios',
  'Wishbone',
  'Zitro',
] as const;

export const GAMES_FEATURES_MEXICO: readonly BffGamesCategory[] = [
  BffGamesCategory.BonusGame,
  BffGamesCategory.BuyFeature,
  BffGamesCategory.InfinityReels,
  BffGamesCategory.FixedJackpots,
  BffGamesCategory.Multiplier,
  BffGamesCategory.Bingo,
  BffGamesCategory.BonusWheel,
  BffGamesCategory.Gamble,
  BffGamesCategory.Respins,
  BffGamesCategory.RandomWildsAdditionalWilds,
  BffGamesCategory.StickyWilds,
  BffGamesCategory.Avalanche,
  BffGamesCategory.ClusterPays,
  BffGamesCategory.LevelUp,
  BffGamesCategory.ExpandingSymbols,
  BffGamesCategory.PaidRespin,
  BffGamesCategory.SpreadingWildsOrWildRush,
  BffGamesCategory.ExpandingWildWithRespin,
  BffGamesCategory.WildNudge,
  BffGamesCategory.Megaways,
  BffGamesCategory.LockedReels,
  BffGamesCategory.AdditiveSymbol,
] as const;
